
import { defineComponent, ref, onMounted } from "vue";

import { useTypedStore } from "@/store";
import router from "@/router";

export default defineComponent({
  name: "Splash",
  setup() {
    const splashRef = ref<HTMLElement | null>(null);
    const { state } = useTypedStore();

    const screenOneActive = ref<boolean>(true);
    const screenTwoActive = ref<boolean>(false);

    const splashScreenTime = 5000;

    onMounted(() => {
      splashRef.value?.addEventListener("click", () => {
        if (screenOneActive.value) {
          advanceToScreenTwo();
        } else if (screenTwoActive.value) {
          screenOneActive.value = false;
          screenTwoActive.value = false;

          router.push("./game");
        }
      });

      if (!state.isDev) {
        setTimeout(() => {
          if (screenOneActive.value) {
            advanceToScreenTwo();
          }
        }, splashScreenTime);
      }
    });

    const advanceToScreenTwo = () => {
      screenOneActive.value = false;
      screenTwoActive.value = true;

      if (!state.isDev) {
        setTimeout(() => {
          if (screenTwoActive.value) {
            router.push("./game");
          }
        }, splashScreenTime);
      }
    };

    return {
      splashRef,
      screenOneActive,
      screenTwoActive,
    };
  },
});
